// extracted by mini-css-extract-plugin
export var label = "_43-1";
export var reminder = "_43-0";